import React from 'react';
import sharedAction from 'shared/routes/firms/firm';
import Layout from 'desktop/components/Layout';
import LINKS from 'desktop/constants/navigation';
import Firm from './Firm';

async function action(params) {
  const data = await sharedAction(params);

  if (!data) {
    return null;
  }

  const {
    queryParams,
    title,
    description,
    firmInfo,
    tab,
    news,
    newsPage,
    newsPageCount,
    query,
    url,
    shouldShowOffers,
    transportType,
    firmsTypes,
    isMotoSearch,
    isCommercial,
    currentPage,
  } = data;

  if (!shouldShowOffers && params.params.tab === 'about') {
    const redirectUrl = url.replace('about', '').replace('//', '/');

    return {
      status: 301,
      redirect: redirectUrl,
    };
  }

  return {
    chunks: ['firm'],
    title,
    routeName: 'firms',
    shouldSetIndex: true,
    description,
    component: (
      <Layout navLinks={LINKS.SPARES} currentRoute={url} withBranding>
        <Firm
          queryParams={queryParams}
          currentPage={currentPage}
          firmInfo={firmInfo}
          tab={tab}
          news={news}
          newsPage={newsPage}
          newsPageCount={newsPageCount}
          query={query}
          url={url}
          shouldShowOffers={shouldShowOffers}
          transportType={transportType}
          firmsTypes={firmsTypes}
          isMotoSearch={isMotoSearch}
          isCommercial={isCommercial}
        />
      </Layout>
    ),
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/desktop/routes/firms/firm/index.js